import React, { useEffect, useState } from 'react';
import { Card, Table, Spinner, Alert, Form, Pagination } from 'react-bootstrap';
import EventService from "../../services/EventService.js";

const DraftEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
   const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    const fetchDraftEvents = async () => {
      try {
        const response = await EventService.fetchDraftEvents();
        if (response.data?.success) {
          
          // ✅ Filter only isDraft === true and sort by creationDate DESC
          const draftEvents = (response.data.data || [])
            .filter(e => e.isDraft)
            .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));

          setEvents(draftEvents);
        } else {
          setError('Failed to fetch draft events.');
        }
      } catch (err) {
        console.error('API error:', err);
        setError('An error occurred while fetching events.');
      } finally {
        setLoading(false);
      }
    };

    fetchDraftEvents();
  }, []);

  // Pagination logic
  const indexOfLast = currentPage * pageSize;
  const indexOfFirst = indexOfLast - pageSize;
  const currentEvents = events.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(events.length / pageSize);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  // View & Share handlers
  const onViewEvent = (eventId) => {
    const url = `/create-events/${eventId}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const onShareEvent = (eventId) => {
    const url = `/view-event/${eventId}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="fw-bold d-flex justify-content-between align-items-center">
        Draft Events
        <Form.Select
          value={pageSize}
          onChange={handlePageSizeChange}
          style={{ width: "100px" }}
          size="sm"
        >
          {[5, 10, 20, 50, 100].map(size => (
            <option key={size} value={size}>{size} / page</option>
          ))}
        </Form.Select>
      </Card.Header>

      {loading ? (
        <div className="p-3 text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <Alert variant="danger" className="m-3">
          {error}
        </Alert>
      ) : (
        <>
          <Table bordered hover>
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Event Name</th>
                <th>Created On</th>
                <th>Edit</th>
                <th>Share</th>
              </tr>
            </thead>
            <tbody>
              {currentEvents.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No draft events found.
                  </td>
                </tr>
              ) : (
                currentEvents.map((event, idx) => (
                  <tr key={event.id}>
                    <td>{indexOfFirst + idx + 1}</td>
                    <td>{event.eventName}</td>
                    <td>{new Date(event.createdOn).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                  })}</td>
                    <td>
                      <button
                        className="btn btn-link p-0"
                        style={{
                          color: '#0d6efd',
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer'
                        }}
                        onClick={() => onViewEvent(event.id)}
                      >
                        Edit
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn btn-link p-0"
                        style={{
                          color: '#0d6efd',
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer'
                        }}
                        onClick={() => onShareEvent(event.id)}
                      >
                        Share
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <Pagination className="justify-content-center">
              {[...Array(totalPages)].map((_, idx) => (
                <Pagination.Item
                  key={idx + 1}
                  active={idx + 1 === currentPage}
                  onClick={() => handlePageChange(idx + 1)}
                >
                  {idx + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          )}
        </>
      )}
    </Card>
  );
};

export default DraftEvents;
